import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENTS]: {
		url:'/company/:companyId/incidents/:incidentId/comments/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENT]: {
		url: '/company/:companyId/incidents/:incidentId/comments/:commentId/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].CREATE_INCIDENT_COMMENT]: {
		url:'/company/:companyId/incidents/:incidentId/comments/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PATCH_INCIDENT_COMMENT]: {
		url: '/company/:companyId/incidents/:incidentId/comments/:commentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PUT_INCIDENT_COMMENT]: {
		url: '/company/:companyId/incidents/:incidentId/comments/:commentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].DELETE_INCIDENT_COMMENT]: {
		url: '/company/:companyId/incidents/:incidentId/comments/:commentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}